// make tooltip text more readable/sanitized
export const cleanCategoryNamePath = (rawPath: string) => {
  const rawPathArray = rawPath.split('/')
  return rawPathArray.filter(Boolean).join(' / ')
}
